import styled, { keyframes } from 'styled-components'

import Progress from 'components/progress'
import React from 'react'
import Timeline from 'sections/about/parts/Timeline'

class TabsPart extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tab: "skills"
        }
    }

    render() {
        const TabContainer = styled.div`
            min-height: 400px;
            margin-top: 20px;
            @media (max-width:767px) {
                margin-top: 50px;
                padding: 0 20px;
            }
        `
        const TabSelectors = styled.div`
            display: flex;
        `
        
        const ColorAnimation = keyframes`
            0%  {border-color: #04e5e5;}
            10% {border-color: #f37055;}
            20% {border-color: #ef4e7b;}
            30% {border-color: #a166ab;}
            40% {border-color: #5073b8;}
            50% {border-color: #04e5e5;}
            60% {border-color: #07b39b;}
            70% {border-color: #6fba82;}
            80% {border-color: #5073b8;}
            90% {border-color: #1098ad;}
            100% {border-color: #f37055;}
        `
        const TabSelector = styled.button`
            color: #fff;
            font-size: 20px;
            font-weight: bold;
            background-color: transparent;
            border: none;
            margin: 0 10px 0 0;
            border-bottom: 2px solid #fff;
            transition: .5s;
            &:hover, &.active {
                animation: ${ColorAnimation} 10s infinite alternate;
            }
            &:focus {
                outline: none;
            }
            @media (max-width: 767px) {
                font-size: 18px;
            }
        `

        const Tabs = styled.div`
            margin-top: 20px;
        `

        const Fade = keyframes`
            0% {
                opacity: 0;
            }
            100% {
                opacity: 1;
            }
        `

        const Tab = styled.div`
            display: none;
            animation: ${Fade} 1s forwards;
        `

        return(
            <TabContainer>
                <TabSelectors>
                    <TabSelector className={this.state.tab === "skills" ? "active" : ""} onClick={() => this.setState({tab: "skills"})}>
                        Skills
                    </TabSelector>
                    <TabSelector className={this.state.tab === "experience" ? "active" : ""} onClick={() => this.setState({tab: "experience"})}>
                        Experience
                    </TabSelector>
                    <TabSelector className={this.state.tab === "education" ? "active" : ""} onClick={() => this.setState({tab: "education"})}>
                        Education
                    </TabSelector>
                </TabSelectors>
                <Tabs>
                    <Tab style={{
                        display: this.state.tab === "skills" ? "block" : "none"
                    }}>
                        <Progress value={90} text="Node.js" />
                        <Progress value={80} text="React / React Native" />
                        <Progress value={70} text="Angular" />
                        <Progress value={70} text="TypeScript" />
                        <Progress value={90} text="PHP" />
                        <Progress value={70} text="Java" />
                        <Progress value={70} text="ASP.NET" />
                        <Progress value={80} text="SQL / NoSQL" />
                        <Progress value={60} text="AWS" />
                    </Tab>
                </Tabs>
                <Tabs>
                    <Tab style={{
                            display: this.state.tab === "experience" ? "block" : "none"
                        }}>
                        <Timeline data={{
                                "2019 - now" :  {
                                    title: "Senior Software Developer, JavaScript",
                                    institution: "iOlap inc. Frisco/Austin/Rijeka, USA, Croatia",
                                    description: "Provide oversight through code and design reviews for features delivered by other developers within the iOlap engineering team. Develop back-end/front-end and UI development across multiple product sets. Work with vendor platforms and advertising networks. Develop test plans and test automation for features and/or products. Lead feature development being delivered by multiple engineers. Mentor junior members of the team, love seeing them grow and mature into senior developers. Development of various types of applications using Node, Angular, React, GraphQL, REST etc. and ensure concepts are delivered accordingly"
                                },
                                "2011 - 2019" :  {
                                    title: "Web Developer",
                                    institution: "Amadria Park / Milenij Hoteli d.o.o / Solaris d.d Croatia",
                                    description: "I'am senior developer in one of the biggest hotels group in Croatia, with responsibility for managing the technological requirements for our web solutions an IT systems My main role is to assure the successful execution of the company’s business mission through development and deployment of the company’s web presence. This requires envisioning the company’s service offerings as a web-based business, leading implementation of web applications, and planning for risk and growth. Responsibilities. Strategy & Planning - In my work Strategy & Planning is very important process and needs continuos improvement so I follow a Japanese philosophy called “Kaizen,” which focuses on continuous improvement using small steps. When my team work on any website, they should be thinking of Kaizen because the version they just published is not the final version. There doesn’t even have to be a final version. I can always make improvements, and the very nature of a website will allow me to introduce these at any time. This is because a website isn’t a magazine that I print and sell: once a magazine copy is out of my hands, I cannot make any changes or fix any spelling mistakes or errors. A website, however, sits on our server: if you find a mistake, I can fix it right away. In the same vein, I can introduce gradual improvements and updates to make our website more effective in serving its function. Using the results of users measurements, I can identify problem areas. Perhaps our visitors cannot find the RSS feed link, or our bounce rate is too high or an important page on our website isn’t getting enough visits. Whatever the problem is, there will always be a way to improve things. Implementation & Deployment - One of my responsibilities is to implement and deploy all kinds of software and web apps to my teams. I'm focused on deploying in so called 'pieces' Deploying in pieces helps our business by concentrating on one facet of our business process and perfecting the software for that specific procedure. Additionally, it is easier to train users on segments of the system instead of requiring them to learn one massive overhaul. By implementing one chunk at a time, it takes off pressure from all parties involved. Web Operations - My job is to have a deep understanding of how things work: “a complete systemic view of general site (apps) architecture.” However, I need to be sure that all of it works all of the time: the app, the stack, the hardware, the network. Whatever technology the business needs, it must work, it must performs and it must be able to meet demand. Also, I'm responsible for incorporating new technologies in the architecture to improve availability and reduce costs, constantly analyzing systems to improve efficiency and capacity planning to understand growth well enough to ensure provisioning and deployment outpace need"
                                },
                                "2011 - now" : {
                                    title: "Freelancer, Fullstack Web Developer",
                                    institution: "Freelance projects - worldwide",
                                    description: "As full-stack developer I was working on many projects that needs all sorts of technical skills in backend development and also frontend development I'am an experienced developer with strong knowledge in various programming languages. I'am developing apps and websites for more than 10 years and I have many satisfied customers in my portfolio. What I do: Programming languages - PHP, Java, .NET, JavaScript. Backend development frameworks - Spring, SpringBoot, Laravel, Codeigniter, ASP.NET, ASP.NET Core. JavaScript frameworks & Libraries - React, Angular, Vue, JQuery. Web frontend & CSS frameworks - Bootstrap, Material, Semantic UI, Foundation, Bulma, UIKit. Web CMS - Wordpress, October CMS, Joomla, Drupal, Typo3. Mobile - React Native, Ionic, Framework7. API development platforms - Booking.com, AirBNB, WebHotelier, Expedia, PHOBS, BookingSync. Web apps - Progressive web apps development. Version Control Systems - GIT. Cloud, Hosting setup & Server OS - Linux (CentOs, Fedora, Ubuntu), WHM, CPanel, Apache, NGINX, Microsoft Azure, AWS, DigitalOcean. SEO, SEM - optimize content of webpages, Google Analitycs implementation, AdWord campaigns, Ecommerce tracking"
                                },
                                "2009 - 2010" : {
                                    title: "Web Administrator",
                                    institution: "ORION d.o.o - Varaždin, Croatia",
                                    description: "Many small web sites mostly build in Joomla. Plugin development in PHP. I was writer, editor and web administrator for different companies. What I do: Brand Development, Illustration, Studio Work, Methodology, PHP Development"
                                },
                                "2008 - 2009" : {
                                    title: "IT System Administrator",
                                    institution: "NET-ART d.o.o. - Varaždin, Croatia",
                                    description: "IT service. Detect hardware and software issues on computers. Hardware and Software installation, computer repair, client education for MS Office and other IT products, network troubleshooting, OS installation on server and client computers, etc."
                                }
                            }
                        }
                    />
                    </Tab>
                    <Tab style={{
                            display: this.state.tab === "education" ? "block" : "none"
                        }}>
                        <Timeline data={{
                             "2009 - 2012" : {
                                title: "Information Technology",
                                institution: "FOI ( Faculty of Organization and Informatics )",
                                description: "Learn: information technology in business for three years"
                            },
                            "2002 - Now" : {
                                title: "Life Long Learning",
                                institution: "Certifications",
                                description: "Continuous learning process from online sources like Udemy, Pluralsight, AWS and Microsoft Learning Centre"
                            },
                                
                                "2002 - 2003" : {
                                    title: "IT Service and Maintenance",
                                    institution: "Ivora ( IT and Management School )",
                                    description: "Learn: IT Service, Network troubleshooting, hardware repair, software install, OS troubleshooting, Windows and Linux maintenance"
                                },
                                "2002 - 2003" : {
                                    title: "Web Design Concepts and Development",
                                    institution: "Ivora ( IT and Management School )",
                                    description: "Learn: Web Design, Html, CSS, Graphic Design, PHP"
                                },
                                
                                "-" :  {
                                    title: "Electrical Engineering",
                                    institution: "MEC ( The Secondary School of Electromechanical engineering )",
                                    description: "Learn: Electrical Engineering, SSS"
                                },
                               
                            }
                        }
                    />
                    </Tab>
                </Tabs>
            </TabContainer>
        )
    }
}

export default TabsPart